export default "__VITE_ASSET__hsF_Fq3r__"